<template>
    <SelectDropDown
            :id="id"
            :name="name"
            :label="label"
            @selection-change="countrySelected"
            :options="professions"
            :defaultSelected="defaultSelected ? {id: defaultSelected.iso} : professions[0]"
    />
</template>

<script>
    import SelectDropDown from "@/shared/components/form/SelectDropDown";
    import sharedService from "@/services/shared.service";

    export default {
        name: "ProfessionDropdown",
        components: {SelectDropDown},
        props: {
            id: String,
            name: String,
            label: String,
            defaultSelected: Object
        },
        created() {
            sharedService.fetchAllProfessions()
                .then(({data}) => {
                    this.professions.push({
                        id: 'none',
                        name: '(всички)'
                    });
                    data.forEach(country => this.professions.push(country));
                });
        },
        data() {
            return {
                professions: []
            }
        },
        methods: {
            countrySelected(value) {
                this.$emit('selection-change', {
                    id: value.dropDownId,
                    isDropdown: true,
                    name: value.name,
                    label: value.label,
                    currentValueId: value.currentValue ? value.currentValue.id === 'none' ? '' : value.currentValue.id : '',
                    currentValue: value.currentValue ? value.currentValue.id === 'none' ? '' : value.currentValue.name : '',
                    oldValue: value.oldValue
                });
            }
        }
    }
</script>

<style scoped>

</style>
